module.exports = __webpack_public_path__ + "static/img/8.349b5f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/8.png
// module id = QeYk
// module chunks = 0